
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import { useRoute } from 'vue-router'

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import BlockUI from 'primevue/blockui';

import jsonAsistencia from '@/data/asistencia.json';
import jsonCountries from '@/data/countries.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';


interface OpcionAsistencia {
  id: string;
  descripcion: string;
}


interface Pais {
  code: string;
  value: string;
}


export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Dropdown,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      textoBoton:'',
      withHash:false,
      paises: [] as Pais[],
      selectedCountry: {"code": "+54", "value": "Argentina"} as Pais,
      isSubmitting: false,
      asistenciaSiNo:[] as OpcionAsistencia[],
      acreditado: undefined as unknown as Acreditado,
      formData: {
        nombre: '',
        apellido: '',
        mail: '',
        empresa: '',
        codigoArea: '',
        numeroTelefono: '',
        asiste: undefined as unknown as OpcionAsistencia,
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required('Ingrese su nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese su apellido').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
        numeroTelefono: yup.string().required('Ingrese el número de teléfono').matches(/^\d+$/, 'Sólo se permiten números'),
        codigoArea: yup.string().required('Ingrese el código de área').matches(/^\d+$/, 'Solo se permiten números'),
        empresa: yup.string().required('Ingrese su empresa').min(2, 'Al menos 2 letras'),
        asiste: yup.mixed().required('Seleccione si asistirá'),
      });
    }
  },
  methods: {
    cancelarAcreditacion() {
      this.$router.go(0);
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        this.acreditado.tipoAcreditado = {"id": 641} as TipoAcreditado;
        this.acreditado.nombre = this.formData.nombre;
        this.acreditado.apellido = this.formData.apellido;
        this.acreditado.mail = this.formData.mail;
        this.acreditado.empresa = this.formData.empresa;
        this.acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.numeroTelefono;
        this.acreditado.cantidad = 1;
        this.acreditado.notificar = true;
        

        this.acreditado.datos = {} as any;
        if (!this.withHash) {
          this.acreditado.estadoAcreditado = { "id": 2 } as EstadoAcreditado;
          this.acreditado.datos["3142"] = "SI";
        } else {
          this.acreditado.datos["3142"] = this.formData.asiste?.descripcion;

          if (this.acreditado.datos["3142"] == "SI") {
            this.acreditado.estadoAcreditado = { "id": 2 } as EstadoAcreditado;
          } else {
            this.acreditado.estadoAcreditado = { "id": 1 } as EstadoAcreditado;
          }
        }
        const acreditadoActualizado: Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, suiteConfig.token, this.acreditado);

        if (acreditadoActualizado) {
          this.isSubmitting = false;
          Swal.fire({
            title: "¡Ya estás confirmado!",
            html: "A la brevedad recibirás un correo con la confirmación y un QR para facilitar tu ingreso al evento.<br/><br/>¡Muchas Gracias!",
            icon: "success",
          }).then(() => {
            this.cancelarAcreditacion();
            window.location.href = "https://acreditacion.qreventos.com/desafios2023/acreditarme ";
          });
        }

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  },
  async mounted() {
    const route = useRoute();
    const hash = route.params.hash as string;
    
    this.paises = jsonCountries;
    this.asistenciaSiNo = jsonAsistencia;

    if (hash === undefined) {
      this.acreditado = new Object() as Acreditado;
      this.acreditado.modificado = 2; // SAVE
      this.formData.asiste = {"id":"SI" , "descripcion" : "SI"}; 
      this.textoBoton = "REGISTRARME";
      return;
    }
 

    

    this.acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, suiteConfig.token, hash);
    if (!this.acreditado) {
      Swal.fire({ title: "Atención!!!", html: "El acreditado no existe.", icon: "error" }).then(() => {
        window.location.href = "https://acreditacion.qreventos.com/desafios2023/acreditarme";
      });
      return;
    }

    if(this.acreditado.estadoAcreditado.id == 2) {
      Swal.fire({ title: "¡Muchas gracias!", html: "Ya estás confirmado para participar del evento.", icon: "success" }).then(() => {
        window.location.href = "https://acreditacion.qreventos.com/desafios2023/acreditarme";
      });
      return;
    }

    this.withHash = true;
    this.formData.nombre = this.acreditado.nombre;
    this.formData.apellido = this.acreditado.apellido;
    this.formData.mail = this.acreditado.mail;
    this.formData.empresa = this.acreditado.empresa;
    this.textoBoton = "CONFIRMAR";
    this.acreditado.modificado = 1;
    
    
  }
});
